module.exports = __webpack_public_path__ + "static/media/ChaseFite-resume.2d499232.pdf";